import React from 'react';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import '../styles/stylesGobierno.css';

const Gobierno = () => {
  const { hash } = useLocation();

  // Manejo del scroll suave al ancla
  useEffect(() => {
    if (hash) {
      const elem = document.querySelector(hash);
      if (elem) elem.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [hash]);

  // Array con los periodos para renderizarlos limpiamente
  const periodos = [
    "2021 - 2023",
    "2023 - 2025",
    "2025 - 2027"
  ];

  return (
      <div className="Gob">
        <section className="presidencia" id="presidencia">

          {/* Título de sección opcional, si quisieras agregarlo */}
          {/* <h2 className="section-title">Autoridades</h2> */}

          <div className="presidencia__container">
            {/* Card Presidente */}
            <div className="presidencia__card">
              <div className="presidencia__image-container">
                <img
                    src="https://bbbqjdnfrlibwibbyjmb.supabase.co/storage/v1/object/public/resources/fotoPresidencia2.webp"
                    alt="Daniel Alberto Ribero"
                    className="presidencia__foto"
                />
              </div>

              <div className="presidencia__content">
                {/* Separamos el cargo del nombre para mejor jerarquía */}
                <h4 className="presidencia__cargo">
                  Presidente Comunal
                </h4>
                <h3 className="presidencia__nombre">
                  Daniel Alberto Ribero
                </h3>

                {/* Sección de períodos con diseño de "chips" */}
                <div className="presidencia__periodos-container">
                  <p className="presidencia__periodo-label">Gestiones:</p>
                  <ul className="presidencia__lista-fechas">
                    {periodos.map((periodo, index) => (
                        <li key={index} className="fecha-chip">{periodo}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
  );
}

export default Gobierno;